import { motion } from 'framer-motion';
import { FiArrowUpRight, FiDownloadCloud, FiSmartphone, FiCpu, FiServer, FiCheckCircle } from 'react-icons/fi';

function Hero() {
    return (
        <div className="container">
            <div className="hero-card">
                {/* Left Side: Main Info aligned directly with Resume Profile */}
                <div className="hero-content">
                    <div className="hero-eyebrow">Flutter & FastAPI Developer</div>
                    <h1 className="hero-title">Basharat Ali Sahito</h1>
                    <p>
                        Flutter Developer with experience building cross-platform mobile apps,
                        REST APIs with FastAPI, and AI integration. Passionate about clean UI,
                        MVVM architecture, and production-ready systems.
                    </p>

                    <div className="hero-actions">
                        <a
                            href="https://drive.google.com/file/d/1pDf5SFfVzdPtyZ00p_aqJMRH-JeS7ye5/view?usp=sharing"
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-primary"
                        >
                            <FiDownloadCloud /> Download Resume
                        </a>
                        <a href="#projects" className="btn btn-outline-primary">
                            View Projects <FiArrowUpRight />
                        </a>
                    </div>

                    <div className="hero-badges">
                        <span className="feature-pill">Flutter / Dart</span>
                        <span className="feature-pill">FastAPI / Python</span>
                        <span className="feature-pill">Firebase & Firestore</span>
                        <span className="feature-pill">Provider / MVVM</span>
                    </div>
                </div>

                {/* Right Side: Replaced generic "Highlights" with concrete focus areas */}
                <motion.div
                    className="hero-visual"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="hero-visual-shell">
                        <div className="hero-visual-card">
                            <h3 className="hero-visual-title">Core Focus</h3>
                            <div className="hero-visual-features">
                                <span className="hero-visual-feature">
                                    <FiSmartphone style={{ marginRight: '6px' }} /> Mobile App Dev
                                </span>
                                <span className="hero-visual-feature">
                                    <FiCpu style={{ marginRight: '6px' }} /> AI Integration
                                </span>
                                <span className="hero-visual-feature">
                                    <FiServer style={{ marginRight: '6px' }} /> FastAPI & REST APIs
                                </span>
                                <span className="hero-visual-feature">
                                    <FiCheckCircle style={{ marginRight: '6px' }} /> Live Google Play Apps
                                </span>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}

export default Hero;